import { AwsRum, AwsRumConfig, TelemetryEnum } from 'aws-rum-web';
import {
  AWS_RUM_ALLOW_COOKIES,
  AWS_RUM_APPLICATION_ID,
  AWS_RUM_APPLICATION_VERSION,
  AWS_RUM_ENDPOINT,
  AWS_RUM_ENABLED,
  AWS_RUM_ENABLE_XRAY,
  AWS_RUM_IDENTITY_POOL_ID,
  AWS_RUM_REGION,
  AWS_RUM_SESSION_SAMPLE_RATE,
  AWS_RUM_SIGNING,
} from './constants/envVariables';

let awsRum: AwsRum | undefined;

const getSessionSampleRate = (): number => {
  if (
    Number.isFinite(AWS_RUM_SESSION_SAMPLE_RATE) &&
    AWS_RUM_SESSION_SAMPLE_RATE >= 0 &&
    AWS_RUM_SESSION_SAMPLE_RATE <= 1
  ) {
    return AWS_RUM_SESSION_SAMPLE_RATE;
  }

  return 1;
};

export const initializeAwsRum = (): AwsRum | undefined => {
  if (!AWS_RUM_ENABLED || awsRum) {
    return awsRum;
  }

  if (!AWS_RUM_APPLICATION_ID || !AWS_RUM_REGION) {
    console.warn('AWS RUM is enabled but its application ID or region is missing.');
    return undefined;
  }

  if (AWS_RUM_SIGNING && !AWS_RUM_IDENTITY_POOL_ID) {
    console.warn('AWS RUM signing requires a Cognito identity pool ID.');
    return undefined;
  }

  const config: AwsRumConfig = {
    allowCookies: AWS_RUM_ALLOW_COOKIES,
    enableXRay: AWS_RUM_ENABLE_XRAY,
    sessionSampleRate: getSessionSampleRate(),
    signing: AWS_RUM_SIGNING,
    telemetries: [
      TelemetryEnum.Errors,
      TelemetryEnum.Performance,
      TelemetryEnum.Http,
    ],
  };

  if (AWS_RUM_ENDPOINT) {
    config.endpoint = AWS_RUM_ENDPOINT;
  }

  if (AWS_RUM_IDENTITY_POOL_ID) {
    config.identityPoolId = AWS_RUM_IDENTITY_POOL_ID;
  }

  try {
    awsRum = new AwsRum(
      AWS_RUM_APPLICATION_ID,
      AWS_RUM_APPLICATION_VERSION,
      AWS_RUM_REGION,
      config
    );
  } catch (error) {
    console.warn('AWS RUM could not be initialized.', error);
  }

  return awsRum;
};
